/**
 * @generated SignedSource<<6413a93b842c5a42dc9d9e4b9397854c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomSidebar_room$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity">;
  readonly " $fragmentType": "RoomSidebar_room";
};
export type RoomSidebar_room$key = {
  readonly " $data"?: RoomSidebar_room$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomSidebar_room">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomSidebar_room",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    }
  ],
  "type": "Room",
  "abstractKey": null
};

(node as any).hash = "9716d5b09c35fd078d0d8e3d3b5c596b";

export default node;
